import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/hooks/useAuth';
import { useHousehold } from '@/contexts/HouseholdContext';
import { cn } from '@/lib/utils';
import { ChevronUp, Gift, UserRound, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

export function AccountMenu({ collapsed }: { collapsed: boolean }) {
  const { user } = useAuth();
  const { isInHousehold } = useHousehold();
  const name = user?.username || 'Account';
  const initial = user?.first_name?.charAt(0) || name.charAt(0).toUpperCase();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          aria-label="Account menu"
          className={cn(
            'min-w-0 gap-2 px-1',
            collapsed ? 'h-9 w-9' : 'flex-1 justify-start'
          )}
        >
          <span
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted text-xs"
            aria-hidden="true"
          >
            {initial}
          </span>
          {!collapsed && (
            <>
              <span className="min-w-0 flex-1 truncate text-left">{name}</span>
              <ChevronUp className="h-3 w-3 shrink-0 text-muted-foreground" />
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side={collapsed ? 'right' : 'top'}
        align="start"
        className="w-56"
      >
        <DropdownMenuLabel className="truncate">{name}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/preferences?section=account">
            <UserRound className="mr-2 h-4 w-4" />
            Your account
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/household?view=manage">
            <Users className="mr-2 h-4 w-4" />
            {isInHousehold ? 'Manage household' : 'Set up household'}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/invite">
            <Gift className="mr-2 h-4 w-4" />
            Invite friends
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
